<script setup lang="ts">
import { defineProps } from 'vue';
import { Hourglass, Check, BanknoteArrowUp, BanknoteArrowDown } from '@lucide/vue';
const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: (value) => ['validated', 'pending', 'released', 'captured'].includes(value)
  }
})
</script>

<template>
  <span :class="[
    'tw:rounded tw:px-2 tw:py-1 tw:text-xs tw:font-medium tw:inline-flex tw:items-center tw:gap-1',
    props.status === 'pending' ? 'tw:bg-yellow-100 tw:text-yellow-800' : '',
    props.status === 'validated' ? 'tw:bg-green-100 tw:text-green-800' : '',
    props.status === 'released' ? 'tw:bg-blue-100 tw:text-blue-800' : '',
    props.status === 'captured' ? 'tw:bg-red-100 tw:text-red-800' : ''
  ]">
    <template v-if="props.status === 'pending'">
      <Hourglass class="tw:w-3 tw:h-3" />
    </template>
    <template v-else-if="props.status === 'validated'">
      <Check class="tw:w-3 tw:h-3" />
    </template>
    <template v-else-if="props.status === 'released'">
      <BanknoteArrowUp class="tw:w-3 tw:h-3" />
    </template>
    <template v-else-if="props.status === 'captured'">
      <BanknoteArrowDown class="tw:w-3 tw:h-3" />
    </template>
    {{ props.status }}
  </span>
</template>

<style scoped>

</style>